import React, {ReactElement} from 'react';
import {graphql, useStaticQuery} from 'gatsby';

import NavigationComponent from '@fo/designSystem/Navigation/Navigation';
import {ETheme} from '@fo/root/Templates/TideTemplates/shared/enums/themes';

interface INavigationWrapperWithQuery {
  hideCtaButton?: boolean;
  hideTideBranding?: boolean;
  theme?: ETheme;
  isSkipQuoteFormAndRedirectToTide?: boolean;
}

function NavigationWrapperWithQuery({
  hideCtaButton,
  hideTideBranding,
  theme,
  isSkipQuoteFormAndRedirectToTide,
}: INavigationWrapperWithQuery): ReactElement {
  const navigationData = useStaticQuery(graphql`
    query NavigationQuery {
      contentfulNavigationGlobalContainer(locale: {eq: "en-GB"}) {
        ...NavigationGlobalContainer
      }
    }
  `);

  const {ctaButton, loginMenuText, alternativeJourneyLink, sections} =
    navigationData.contentfulNavigationGlobalContainer;

  return (
    <NavigationComponent
      ctaButton={!hideCtaButton ? ctaButton : undefined}
      loginMenuText={loginMenuText}
      alternativeJourneyLink={alternativeJourneyLink}
      sections={sections}
      hideTideBranding={hideTideBranding}
      theme={theme}
      isSkipQuoteFormAndRedirectToTide={isSkipQuoteFormAndRedirectToTide}
    />
  );
}

export default NavigationWrapperWithQuery;
